<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Log In</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
  <eng-login-form
    [returnUrl]="returnUrl"
    (success)="activeModal.dismiss()"
    (switchToRegisterRequested)="onSwitchToRegister()"
    (forgotPasswordRequested)="onForgotPassword()" />
</div>
